
 (() => {
	const debugMode = 1,
		testId = "BBB-UGC",
		logInfo = testId + " -->",
		variation = 1;

	try {

      // checking if UGC Block has been added

      if(document.querySelector(`.product .${testId}__video-container`)){

        let isGloballyMuted = false;

        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        const icons = {
				muted: "https://cdn.shopify.com/s/files/1/0273/9096/7907/files/mute-icon.png?v=1736107093",
				unmuted: "https://cdn.shopify.com/s/files/1/0273/9096/7907/files/unmute-icon.png?v=1736107089"
			};

        const updateAllMuteButtons = (container, isMuted) => {
            try {
                const muteButtons = container.querySelectorAll(".mute-button");
                const videos = container.querySelectorAll("video");

                muteButtons.forEach((button) => {
                    try {
                        button.innerHTML = `<img src="${isMuted ? icons.muted : icons.unmuted}" alt="${isMuted ? "Unmute" : "Mute"}" />`;
                    } catch (err) {
                        if (debugMode) console.error(logInfo, err.message);
                    }
                });

                videos.forEach((video) => {
                    try {
                        video.muted = isMuted;
                    } catch (err) {
                        if (debugMode) console.error(logInfo, err.message);
                    }
                });
            } catch (err) {
                if (debugMode) console.error(logInfo, err.message);
            }
        };
        
        const handleMuteButtons = (fullscreenContainer) => {

          const muteButtons = fullscreenContainer.querySelectorAll(`.mute-button`);

          muteButtons.forEach((muteButton) => {
            muteButton.innerHTML = `<img src="${isGloballyMuted ? icons.muted : icons.unmuted}" alt="${isGloballyMuted ? "Unmute" : "Mute"}" />`;
            
            muteButton.addEventListener("click", (e) => {
                e.stopPropagation();
                isGloballyMuted = !isGloballyMuted;
    
                // Get the fullscreen container and update all videos
                updateAllMuteButtons(fullscreenContainer, isGloballyMuted);
            });
          });
          
        };

        const setupIntersectionObserver = (target, threshold = 0.1) => {
				try {
					const observer = new IntersectionObserver(
						(entries) => {
							entries.forEach((entry) => {
								if (entry.isIntersecting) {
									const waitForAnalytics = setInterval(() => {
										const hasDataLayer = typeof window.dataLayer !== "undefined";
										const hasIgEvents = typeof window.igEvents !== "undefined";
										const hasClarity = typeof window.clarity !== "undefined";

										if (hasDataLayer && hasIgEvents && hasClarity) {
											window.igEvents.push({
												event: `test_${testId}_interaction`
											});
											if (debugMode) console.log("IG event:", `${testId}_variation${variation}`);

											window.dataLayer.push({ event: "ab_test_interaction", test_id: testId, test_variant: `variation${variation}` });
											if (debugMode) console.log("GA4 event:", `${testId}_variation${variation}`);

											window.clarity("set", "ab_test", `${testId}_variation${variation}`);
											if (debugMode) console.log("Clarity event:", `${testId}_variation${variation}`);

											clearInterval(waitForAnalytics);
										}
									}, 100);

									setTimeout(() => clearInterval(waitForAnalytics), 30000);

									observer.disconnect();
								}
							});
						},
						{ threshold }
					);

					observer.observe(target);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

        const handleMobileIntersection = (videoContainer) => {
				window.addEventListener("scroll", function onScroll() {
					window.removeEventListener("scroll", onScroll);
					setupIntersectionObserver(videoContainer, 1);
				});
			};

        const handleVideoThumbnails = () => {

          const videoContainer = document.querySelector(`.${testId}__video-container`);
          
				if (isMobile) {
					handleMobileIntersection(videoContainer);
				} else {
					setupIntersectionObserver(videoContainer, 1);
				}
			};
        
        const handleScrollPagination = (scrollContainer, paginationContainer) => {
            let lastScrollTop = 0;
            scrollContainer.addEventListener("scroll", () => {
                const scrollTop = scrollContainer.scrollTop;
                const scrollDirection = scrollTop > lastScrollTop ? "down" : "up";
                lastScrollTop = scrollTop;
    
                const slides = scrollContainer.querySelectorAll(`.${testId}-video-slide`);
                const dots = paginationContainer.querySelectorAll(".dot");
                const containerHeight = window.innerHeight;
    
                slides.forEach((slide, index) => {
                    const rect = slide.getBoundingClientRect();
                    const slideCenter = rect.top + rect.height / 2;
                    const threshold = containerHeight * 0.4;
    
                    if (scrollDirection === "down") {
                        if (rect.top <= threshold) {
                            dots.forEach((dot) => dot.classList.remove("active"));
                            dots[index].classList.add("active");
                        }
                    } else {
                        if (slideCenter <= containerHeight / 2) {
                            dots.forEach((dot) => dot.classList.remove("active"));
                            dots[index].classList.add("active");
                        }
                    }
                });
            });
        };

        const createVideoSlide = (videoSrc) => {
				const videoWrapper = document.createElement("div");
				videoWrapper.classList.add(`${testId}-video-slide`);

				const video = document.createElement("video");
				video.src = videoSrc;
				video.muted = isGloballyMuted;

				const attributes = {
					playsinline: "",
					loop: "",
					autoplay: "",
					"webkit-playsinline": "",
					disablePictureInPicture: "",
					controlsList: "noplaybackrate nofullscreen nodownload"
				};

				Object.entries(attributes).forEach(([key, value]) => {
					video.setAttribute(key, value);
				});

				const muteButton = document.createElement("div");
				muteButton.classList.add("mute-button");
				muteButton.innerHTML = `<img src="${isGloballyMuted ? icons.muted : icons.unmuted}" alt="${isGloballyMuted ? "Unmute" : "Mute"}" />`;

				muteButton.addEventListener("click", (e) => {
					e.stopPropagation();
					isGloballyMuted = !isGloballyMuted;

					// Get the fullscreen container and update all videos
					const fullscreenContainer = document.querySelector(`.${testId}-videos-full-screen`);
					updateAllMuteButtons(fullscreenContainer, isGloballyMuted);
				});

				videoWrapper.appendChild(video);
				videoWrapper.appendChild(muteButton);
				return videoWrapper;
			};

        const handleVideoIntersection = (video) => {
				if (video.readyState >= 3) {
					video.muted = isGloballyMuted;
					video.play().catch((error) => {
						console.error("Error playing video:", error);
					});
				} else {
					video.load();
					video.addEventListener("loadeddata", () => {
						video.muted = isGloballyMuted;
						video.play().catch((error) => {
							console.error("Error playing video after loading:", error);
						});
					});
				}
			};

        const setupVideoObserver = (scrollContainer) => {
            const videoObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const video = entry.target.querySelector("video");
                        if (entry.isIntersecting) {
                            handleVideoIntersection(video);
                        } else {
                            video.pause();
                            video.currentTime = 0;
                        }
                    });
                },
                {
                    root: scrollContainer,
                    threshold: 0.7
                }
            );

            scrollContainer.querySelectorAll(`.${testId}-video-slide`).forEach((slide) => {
                videoObserver.observe(slide);
            });

            return videoObserver;
        };

        const handleThumbnailClick = (wrapper, index, scrollContainer, fullscreenContainer) => {
				wrapper.addEventListener("click", () => {
					fullscreenContainer.classList.add(`${testId}-active`);
					document.body.style.overflow = "hidden";

					const targetSlide = scrollContainer.children[index];
					targetSlide.scrollIntoView({ behavior: "auto" });

					const targetVideo = targetSlide.querySelector("video");
					targetVideo.muted = false;

					const unlockAutoplay = () => {
						scrollContainer.querySelectorAll("video").forEach((video) => {
							video
								.play()
								.catch(() => {})
								.then(() => {
									video.pause();
								});
						});
					};

					unlockAutoplay();
					handleVideoIntersection(targetVideo);

					window.igEvents.push({
						event: `${testId}-UGC-thumbnail-${index}-click`
					});
					if (debugMode) console.log("IG event:", `${testId}-UGC-thumbnail-${index}-click`);

					// GA4 event
					window.dataLayer.push({ event: "ab_test_action", test_id: testId, test_variant: `variation${variation}`, test_action: `${testId}-UGC-thumbnail-${index}-click` });
					if (debugMode) console.log("GA4 event:", `${testId}-UGC-thumbnail-${index}-click`);
				});
			};

        const handleCloseButton = (closeButton, fullscreenContainer, scrollContainer) => {
				closeButton.addEventListener("click", () => {
					fullscreenContainer.classList.remove(`${testId}-active`);
					document.body.style.overflow = "";

					scrollContainer.querySelectorAll("video").forEach((video) => {
						video.pause();
						// video.muted = true;
					});
				});
			};
        
          const handleFullscreenContainer = () => {
            const fullscreenContainer = document.querySelector(`.${testId}-videos-full-screen`);
  
            const scrollContainer = document.querySelector(`.${testId}-scroll-container`);
  
            const closeButton = fullscreenContainer.querySelector(".close-button");
  
            handleMuteButtons(fullscreenContainer);
  
            const paginationContainer = fullscreenContainer.querySelector(`.pagination-dots`);
  
            handleScrollPagination(scrollContainer, paginationContainer);
            setupVideoObserver(scrollContainer);
  
            const videoWrapper = document.querySelector(`.${testId}__video-wrapper`);
            videoWrapper.querySelectorAll(`.${testId}__video-wrapper-item`).forEach((wrapper, index) => {
                handleThumbnailClick(wrapper, index, scrollContainer, fullscreenContainer);
            });
  
            handleCloseButton(closeButton, fullscreenContainer, scrollContainer);
            document.body.insertAdjacentElement("beforeend", fullscreenContainer);
        };

        const init = () => {
				try {
					handleVideoThumbnails();
					handleFullscreenContainer();
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

        try {
            init();
        } catch (err) {
            if (debugMode) console.error(logInfo, err.message);
        }
        
      }
      
      // checking if UGC Block has been added
      
      } catch(err) {
        if (debugMode) console.error(logInfo, err.message);
      }
})();